export default __webpack_public_path__ + "static/media/jinka-lakshmidevi.21f1cb64.png";